module.exports = __webpack_public_path__ + "static/img/login.d80733a7.png";